import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { Product } from '@packages/gql/generated/shopping/graphql';
import { DownloadFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { Card, CardContent, CardHeader, Stack } from '@packages/shared';
import { defineMessage, useIntl } from 'react-intl';
import { Download } from '../Download';

export type DownloadsCardProps = {
  /** Download data array from given product. */
  downloadsData: Product['downloads'];
};

const message = defineMessage({
  id: 'downloadsCard.header',
  defaultMessage: 'Downloads',
});

/**
 * DownloadsCard component displays all available downloads
 * */
export const DownloadsCard = ({ downloadsData }: DownloadsCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <CardHeader
        title={formatMessage(message)}
        sx={{ borderBottom: 1, borderColor: 'grey.main', py: 1, px: 2 }}
      />
      <CardContent>
        <Stack spacing={1.5}>
          {downloadsData.map((download, idx) => (
            <Download
              downloadData={makeFragmentData(download, DownloadFragmentFragmentDoc)}
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
